import * as React from "react";
import { EntityCardDataExt } from "src/pages/EntityCardPage/EntityCardStore";
import { Alert, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { observer } from "mobx-react-lite";
import { LoaderBox } from "src/components/LoaderBox";
import { ScrollableTable } from "src/components/ScrollableTable";
import { ColumnsSettings } from "src/components/tables/ColumnsSettings";
import styles from "./Bom3Control.module.less";
import { Bom3Data, bom3ControlStore as store } from "./Bom3ControlStore";
import { ObjectServiceExt } from "../../../businessServises.types";
import { Bom3Modal } from "./Bom3Modal";
import { Bom3Actions } from "./Bom3Actions";
import { Bom3Positions } from "../Bom3Positions";
import { Bom3CopyIn } from "./copyIn";
import { Bom3CopyFrom } from "./copyFrom";
import { Bom3EditModal } from "./Bom3EditModal";
import { accessGranted } from "./access";

type PropsBom3Control = {
  info: ObjectServiceExt;
  entityData: EntityCardDataExt;
};

export const Bom3Control: React.FC<PropsBom3Control> = observer((props) => {
  const { entityData, info } = props;
  const entityId = entityData.entity?.id;
  const { objectId } = info;
  React.useEffect(() => {
    if (entityId) {
      store.init(entityId, objectId, entityData.typesMap);
    }
    return () => {
      store.done();
    };
  }, [entityId]);
  if (!entityId) {
    return <Alert type="error" message="Отсутствуют данные экземпляра" />;
  }
  if (store.positions) {
    return (
      <Bom3Positions
        store={store.positions}
        onExit={() => store.setPositions(null)}
      />
    );
  }
  return (
    <LoaderBox
      remoteData={store.data}
      drawReady={(data) => <Inner data={data} />}
    />
  );
});

const Inner: React.FC<{ data: Bom3Data }> = observer(({ data }) => {
  const { tableStore } = data;
  const tools = (
    <>
      <ColumnsSettings store={tableStore} />
      <Bom3Actions />
      {accessGranted("CREATE", data.permissions) && (
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => store.onCreate()}
        >
          BOM
        </Button>
      )}
    </>
  );

  return (
    <div className={styles.box}>
      <ScrollableTable
        tools={tools}
        store={tableStore}
        columns={store.columns}
        onRowClick={(row) => store.openBomPositions(row)}
      />
      <Bom3Modal />
      <Bom3EditModal
        currentBom={store.currentBom}
        close={() => store.closeEdit()}
        onSuccess={() => store.onEditSuccess()}
      />
      <Bom3CopyIn copyStore={store.copyInStore} />
      <Bom3CopyFrom copyStore={store.copyFromStore} />
    </div>
  );
});
